module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-60x60-65c5fd101e7a675a6d8aae2378fce436.png";